import shopBC1 from "./images/reward-nodejs/shop-1.png";
import shopBC2 from "./images/reward-nodejs/shop-2.png";
import shopBC3 from "./images/reward-nodejs/shop-3.png";
import shopBC4 from "./images/reward-nodejs/shop-4.png";
import shopBC5 from "./images/reward-nodejs/shop-5.png";
import shopBC6 from "./images/reward-nodejs/shop-6.png";

import shopRN1 from "./images/reward-rn/shop-1.jpg";
import shopRN2 from "./images/reward-rn/shop-2.jpg";
import shopRN3 from "./images/reward-rn/shop-3.jpg";
import shopRN4 from "./images/reward-rn/shop-4.jpg";
import shopRN5 from "./images/reward-rn/shop-5.jpg";
import shopRN6 from "./images/reward-rn/shop-6.jpg";
import coverRN from "./images/reward-rn/cover.jpg";

import twod1 from "./images/twod/twod1.jpg";
import twod2 from "./images/twod/twod2.jpg";
import twod3 from "./images/twod/twod3.jpg";
import twod4 from "./images/twod/twod4.jpg";
import twod5 from "./images/twod/twod5.jpg";
import twod6 from "./images/twod/twod6.jpg";
import coverTwod from "./images/twod/cover.jpg";

import cu1 from "./images/cu-vote/cu1.jpg";
import cu2 from "./images/cu-vote/cu2.jpg";
import cu3 from "./images/cu-vote/cu3.jpg";
import cu4 from "./images/cu-vote/cu4.jpg";
import cu5 from "./images/cu-vote/cu5.jpg";
import cu6 from "./images/cu-vote/cu6.jpg";
import coverCu from "./images/cu-vote/cover.jpg";

export const projects = [
  {
    title: "Shop Rewards Points System",
    subtitle: "MERN Stack",
    objective:
      "The Shop Reward Point System is a customer engagement and retention solution that has gained immense popularity across diverse industries, from retail to hospitality and beyond. It serves as a symbiotic bridge connecting businesses and their patrons, fostering a mutually beneficial relationship.",
    technology: "Backend: Node.js, Express.js, MongoDB, Version Control: Git",
    description:
      "The 'Shop Rewards Points System' is a dynamic solution that rewards customers for their purchases and allows them to redeem points for various items. With a RESTful API application built using Node.js, Express.js, and MongoDB, hosted on Heroku, the system seamlessly tracks and manages customer points. The frontend user interface, developed using React Native, ensures an intuitive and responsive experience for users. Git was employed as the version control system to facilitate collaboration within the team.\nPoints Award System: Customers earn points based on their purchase amount (e.g., 10 points for every 1000ks spent).\nReward Redemption: Customers can redeem accumulated points for a variety of reward items.",
    githubLink: "https://github.com/nawoption/nodejs-reward",
    category: "web",
    image: shopBC6,
    imageList: [shopBC1, shopBC2, shopBC3, shopBC4, shopBC5, shopBC6],
  },
  {
    title: "Shop Rewards Points System",
    subtitle: "React Native Android",
    objective:
      "The Shop Reward Point System is a customer engagement and retention solution that has gained immense popularity across diverse industries, from retail to hospitality and beyond. It serves as a symbiotic bridge connecting businesses and their patrons, fostering a mutually beneficial relationship.",
    technology: "Frontend: React Native, Version Control: Git",
    description:
      "The 'Shop Rewards Points System' is a dynamic solution that rewards customers for their purchases and allows them to redeem points for various items. With a RESTful API application built using Node.js, Express.js, and MongoDB, hosted on Heroku, the system seamlessly tracks and manages customer points. The frontend user interface, developed using React Native, ensures an intuitive and responsive experience for users. Git was employed as the version control system to facilitate collaboration within the team.\nPoints Award System: Customers earn points based on their purchase amount (e.g., 10 points for every 1000ks spent).\nReward Redemption: Customers can redeem accumulated points for a variety of reward items.",
    githubLink: "https://github.com/nawoption/shop-reward-user-apk",
    category: "android",
    image: coverRN,
    imageList: [shopRN1, shopRN2, shopRN3, shopRN4, shopRN5, shopRN6],
  },
  {
    title: "2D3D Myanmar Lottery Live App",
    subtitle: "React Native Android",
    objective: "Users can watch live 2D lottery results in real-time.",
    technology: "Frontend: React Native, Version Control: Git",
    description:
      "The '2D3D Myanmar Lottery Live App' is a comprehensive mobile application designed to provide users with real-time access to 2D (two-digit) lottery results and a 2D/3D calendar. Successfully launched on the Play Store, the app has garnered over 100,000 downloads. Notably, the server seamlessly handles a daily active user base exceeding 50,000 without any delays.",
    githubLink: "",
    category: "android",
    image: coverTwod,
    imageList: [twod1, twod2, twod3, twod4, twod5, twod6],
  },
  {
    title: "CU Voting",
    subtitle: "React Native Android",
    objective:
      "Design the application to handle an increasing number of voters and candidates, ensuring scalability as the university community grows.",
    technology:
      "Frontend: React Native, Version Control: Git, Styling with StyleSheet for a clean and responsive user interface.",
    description:
      "The Computer University Voting Application is a digital platform designed to streamline and modernize the election process within our university community. The application provides an efficient and secure way for students to cast their votes for candidates vying for roles such as king and queen, mister and miss, prince and princess, fostering a democratic and engaging environment on campus.",
    githubLink: "https://github.com/nawoption/cu-vote",
    category: "android",
    image: coverCu,
    imageList: [cu1, cu2, cu3, cu4, cu5, cu6],
  },
];

export const skills = [
  "JavaScript",
  "PHP",
  "Python",
  "Bootstrap",
  "Tailwind",
  "Node.js",
  "Laravel",
  "React.js",
  "MySQL",
  "MongoDB",
];
